import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

/**
 * Atomically save product slug via Admin SDK callable.
 * @param {{ productId: string, slug: string }} payload
 */
const saveProductSlug = async ({ productId, slug }) => {
  try {
    const callable = functions.httpsCallable('saveProductSlug')
    const result = await callable({ productId, slug })
    return {
      ok: true,
      data: result.data,
    }
  } catch (error) {
    console.error('[saveProductSlug] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default saveProductSlug
